import styled from 'styled-components';
import { rem } from 'polished';

const StyledText = styled.p`
  font-size: ${rem('14px')};
  margin-top: 0;
  margin-bottom: ${rem('10px')};
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    font-size: ${rem('16px')};
  }
`;

const StyledTextBold = styled.strong`
  font-family: ${props => props.theme.fonts.bold};
`;

export { StyledText, StyledTextBold };
